module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7cIFO"))).then(() => parcelRequire('9Lwss'));